const mergeByIds = ({ byIdCurrent, byIdToMerge }) => {
  if (!byIdToMerge) {
    return byIdCurrent;
  }
  const ids = Object.keys(byIdToMerge);

  const byIdNew = ids.reduce((byIdNew, id) => {
    const valueCurrent = byIdCurrent[id];
    const valueToMerge = byIdToMerge[id];
    const valueNew = valueCurrent
      ? { ...valueCurrent, ...valueToMerge }
      : valueToMerge;

    byIdNew[id] = valueNew;
    return byIdNew;
  }, {});

  return { ...byIdCurrent, ...byIdNew };
};

export default mergeByIds;
